<template>
    <div class="m-view__sign">
        <div class="title"></div>
        <div class="slogen main-slogen">
            <p>活动期间，本人前往游戏签到，即可获得结义值、</p>
            <p>游戏道具等福利，3人都达到天数要求，还可额外获得结义福利</p>
        </div>

        <div class="sign-status flex-center-center">
            <div class="sign-item flex-start-start" v-for="(item,index) in team_list" :key="index">
                <div class="nick text-overflow-1">{{ item.nickName }}</div>签到<div class="day">{{ item.checkDays }}</div>天
            </div>

            <div class="sign-item flex-start-start" v-for="n in 3 - team_list.length" :key="'temp-' + n">
                <div class="nick text-overflow-1">— —</div>签到<div class="day">0</div>天
            </div>            
        </div>

        <div class="sign-calendar" v-if="$store.state.task">

            <div class="m-team">
                <div class="slogen">小队签到</div>
                <div class="task-view flex-between-center">
                    <div class="task-item" v-for="(item,index) in $store.state.task[tid_team].subList" :key="index"
                    :class="{'dismiss' : ($store.state.task[tid_team].giftRate) > index  , 'act' : index < ($store.state.task[tid_team].finishRate) && index >= ($store.state.task[tid_team].giftRate)}">
                        <div class="goods-detail">
                            <div class="goods-wrapper">
                                <div class="goods-pic" v-tips="item.giftList[0].giftId"><game-item :locked="true" :id="item.giftList[0].giftId" :num="item.giftList[0].sendNum"></game-item></div>
                            </div> 
                        </div>
                        <div class="require-day">{{ item.value }}天</div>                        
                    </div>
                </div>
                <div class="notice">结义小队3个成员，每个人都完成对应游戏签到天数即可领取</div>  
            </div>

            <div class="m-player">
                <div class="slogen">个人签到</div>
                <div class="sign-view flex-between-center flex-wrap">
                    <div class="sigh-item" v-for="(item,index) in $store.state.task[tid_player].subList" :key="index"
                    :class="{'dismiss' : ($store.state.task[tid_player].giftRate) > index  , 'act' : index < ($store.state.task[tid_player].finishRate) && index >= ($store.state.task[tid_player].giftRate)}">
                        <div class="goods-detail">
                            <div class="goods-wrapper">
                                <div class="goods-pic" v-tips="item.giftList[0].giftId"><game-item :locked="true" :id="item.giftList[0].giftId" :num="item.giftList[0].sendNum"></game-item></div>
                            </div> 
                        </div>
                        <div class="require-day">{{ item.value }}天</div>                             
                    </div>
                </div>
            </div>
           
        </div>

        <div class="u-btn apply sprite sprite-btn-apply" 
        :class="{'dismiss' : $store.state.task[tid_team].giftRate == $store.state.task[tid_team].finishRate && $store.state.task[tid_player].giftRate == $store.state.task[tid_player].finishRate,
            'disabled' : $store.state.task[tid_team].finishRate == 0 && $store.state.task[tid_player].finishRate == 0
        }"
        @click="task_apply()"></div>
    </div>
</template>

<script>
import { apiSignInfo,apiTaskApply } from '@/api/index';

export default {
    data(){
        return {
            tid_team : 't05',
            tid_player : 't06',
            team_list : [],
            //sign_info : {},
        }
    },
    mounted(){
        this.render();
    },
    methods : {
        render (){
            apiSignInfo().then(
                res => {
                    this.team_list = res.data.member;
                    //this.sign_info = res.data;
                },
                rej => {},
            )            
        },
        task_apply(){
            //todo
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            apiTaskApply({taskOrderId : [this.$store.state.task[this.tid_team].taskOrderId,this.$store.state.task[this.tid_player].taskOrderId]})
            .then(
                res => {
                    this.$msg_modal({type : 'success' ,})
                    this.$update_evt();
                },
                rej => {
                    this.$toast(rej.message);
                },
            );
        },        
    },
}
</script>

<style lang="scss" scoped>
.title{
    width: 557px;
    height: 53px;
    margin: 35px auto 5px;
    background-image: url(~@/assets/images/slogen-sign.png);   
}

.slogen.main-slogen{
    margin-bottom: 5px;
    color: #fbdebb;
    font-size: 24px;
    text-align: center;
}

.slogen{
    // margin-bottom: 18px;
    color: transparent;
    font-size: 0;
    text-align: center;
}

.sign-status{
    width: 710px;
    height: 45px;
    line-height: 45px;
    margin: 0 auto 10px;
    background-image: url(~@/assets/images/sign-status.png);

    .sign-item{
        color: #dba166;
        padding: 0 15px;
    }

    .nick{
        width: 4.5em;
        color: #fcda95;
    }

    .day{
        color: #ee3419;
    }
}

.sign-calendar{
    width: 730px;
    height: 993px;
    margin: 0 auto;
    padding-top: 66px;
    background-image: url(~@/assets/images/bg-sign.png);
}

.notice{
    margin-top: 14px;
    text-align: center;
    color: #99573e;

    b{
        font-weight: 400;
        color: #ca3113;
    }
}

.goods-detail{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 82px;
    height: 82px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-item_3.png);     
}

.m-team{
    width: 680px;
    height: 293px;
    margin: 0 auto;
    padding-top: 57px;
    background-image: url(~@/assets/images/sign-pannel_team.png);
    
    .task-view{
        padding: 0 60px;
    }

    .task-item{
        position: relative;
        width: 160px;
        height: 180px;
        padding-top: 40px;
        background-image: url(~@/assets/images/item-sign_team.png);


        .goods-wrapper::after{
            content: '';
            display: block;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            width: 68px;
            height: 68px;
            background-color: rgba($color: #000000, $alpha: 0.5);
            background-repeat: no-repeat;
            background-position: center center;
            pointer-events: none;
        } 

        &.act{
            .goods-wrapper::after{
                display: none;
            } 
            
        }

        &.dismiss{

            .goods-wrapper::after{
                content: '';
                display: block;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                width: 68px;
                height: 68px;
                background-image: url(~@/assets/images/icon-dismiss.png);
                background-repeat: no-repeat;
                background-position: center center;
                pointer-events: none;
            }            
        }

        .require-day{
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            width: 100%;
            height: 39px;
            line-height: 39px;
            text-align: center;
            color: #99573e;
        }
    }
}

.m-player{

    width: 680px;
    height: 592px;
    margin: 25px auto 0;
    padding-top: 60px;
    background-image: url(~@/assets/images/sign-pannel_player.png);

    .sign-view{
        padding: 0 20px;
    }

    .sigh-item{
        position: relative;
        width: 120px;
        height: 150px;
        padding-top: 16px;
        margin-bottom: 20px;
        background-image: url(~@/assets/images/item-sign_player.png);
        text-align: center;
        color: #853b03;


        .goods-wrapper::after{
            content: '';
            display: block;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            width: 68px;
            height: 68px;
            background-color: rgba($color: #000000, $alpha: 0.5);
            background-repeat: no-repeat;
            background-position: center center;
            pointer-events: none;
        } 


        &.act{
            .goods-wrapper::after{
                display: none;
            } 
        }

        &.dismiss{
           // background-image: url(~@/assets/images/sign-item_2_act.png);

            .goods-wrapper::after{
                content: '';
                display: block;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                width: 68px;
                height: 68px;
                background-image: url(~@/assets/images/icon-dismiss.png);
                background-repeat: no-repeat;
                background-position: center center;
                pointer-events: none;
            }            
        }
        
        .require-day{
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            width: 100%;
            height: 39px;
            line-height: 39px;
            text-align: center;
            color: #99573e;
        }
    }
}

.u-btn.apply{
    margin: 25px auto 0;
}
</style>